import {FontAwesomeIcon} from "@fortawesome/react-fontawesome";
import {useState, useRef} from "react";
import {Button} from "react-bootstrap";
import {useTranslation} from "react-i18next";
import useCustomTranslation from "core/customTranslation";
import translations from "./translations";

const TopBarActions = ({items, actions, params, filters}) => {
    const {t: tC} = useTranslation("choices");
    const {t: tS} = useCustomTranslation(translations);
    const [dataSelects, setDataSelects] = useState({
        state: "",
        device_group: "",
        asset_group: "",
        island: "",
        model: "",
        config: "",
    });
    const status = useRef(["s", "p", "e"]);
    const toInteger = ["group_device_id", "group_asset_id", "island_id", "config_id", "model_id"];
    const onChange = (e) => {
        const {name, value} = e.target;
        if (value) {
            if (toInteger.includes(name)) {
                filters.current.chosen[name] = parseInt(value);
            } else {
                filters.current.chosen[name] = value;
            }
        } else {
            delete filters.current.chosen[name];
        }
        if (e.target.dataset.select) {
            let data = {...dataSelects};
            data[e.target.dataset.select] = value;
            setDataSelects(data);
        }
        filters.current.filter();
    };

    const onSearcher = (e) => {
        if (e.target.value) {
            filters.current.chosen.searcher = e.target.value;
        } else {
            delete filters.current.chosen["searcher"];
            filters.current.onChangeSearcher("");
        }
    };
    const handleSubmit = (e) => {
        e.preventDefault();
        filters.current.onChangeSearcher(filters.current.chosen.searcher);
    };

    return (
        <>
            <nav className="navbar navbar-expand actions-control w-100">
                <div className="d-flex m-2 ms-5 w-100">
                    <div className="navbar-brand me-5">{actions.title}</div>
                    <button
                        className="navbar-toggler "
                        type="button"
                        data-bs-toggle="collapse"
                        data-bs-target="#navbarSupportedContent "
                        aria-controls="navbarSupportedContent"
                        aria-expanded="false"
                        aria-label="Toggle navigation">
                        <span className="navbar-toggler-icon"></span>
                    </button>
                    <div id="navbarSupportedContent" className="w-100">
                        <ul className="navbar-nav ">
                            <li className="nav-item">
                                <Button
                                    variant="link"
                                    type="button"
                                    onClick={actions.edit.onClick}
                                    disabled={actions.edit.disabled}>
                                    <FontAwesomeIcon icon="pen" />
                                </Button>
                            </li>
                            <li className="nav-item">
                                <Button
                                    variant="link"
                                    type="button"
                                    onClick={actions.send.onClick}
                                    disabled={actions.send.disabled}>
                                    <FontAwesomeIcon icon="paper-plane" />
                                </Button>
                            </li>
                            <li className="nav-item">
                                <Button
                                    variant="link"
                                    type="button"
                                    onClick={actions.command.onClick}
                                    disabled={actions.command.disabled}>
                                    <FontAwesomeIcon icon="terminal" />
                                </Button>
                            </li>
                            <li className="nav-item me-3">
                                <Button
                                    variant="link"
                                    type="button"
                                    onClick={actions.sendMessage.onClick}
                                    disabled={actions.sendMessage.disabled}>
                                    <FontAwesomeIcon icon="cloud-arrow-up" />
                                </Button>
                            </li>
                            <li>
                                <small className="text-muted ms-3">{tS("filter.search")}</small>
                                <div className="d-flex" role="search">
                                    <form className="d-flex ms-auto" role="search" onSubmit={handleSubmit}>
                                        <input
                                            className="form-control border-end-0 rounded-end-0"
                                            type="search"
                                            name="searcher"
                                            placeholder={tS("filter.search.placeholder")}
                                            aria-label={tS("filter.search")}
                                            onInput={onSearcher}
                                        />
                                        <span
                                            className="input-group-text bg-white border-start-0 rounded-start-0"
                                            id="basic-addon1">
                                            <FontAwesomeIcon icon="fa-solid fa-magnifying-glass" />
                                        </span>
                                    </form>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-status"
                                        name="state"
                                        aria-label={tS("filter.select.status")}
                                        data-select="state"
                                        value={dataSelects.state}
                                        onChange={onChange}>
                                        <option value="">{tS("filter.select.option")}</option>
                                        {status.current.map((stuff, idx) => (
                                            <option key={idx} value={stuff}>
                                                {tC("shippingState." + stuff)}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">{tS("filter.label.status")}</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-device_group"
                                        name="group_device_id"
                                        aria-label={tS("filter.select.device_group")}
                                        data-select="device_group"
                                        value={dataSelects.device_group}
                                        onChange={onChange}>
                                        <option value="">{tS("filter.select.option")}</option>
                                        {params.device_groups.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>
                                                {stuff.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">{tS("filter.label.device_group")}</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-modes"
                                        name="group_asset_id"
                                        aria-label={tS("filter.select.asset_group")}
                                        data-select="asset_group"
                                        value={dataSelects.asset_group}
                                        onChange={onChange}>
                                        <option value="">{tS("filter.select.option")}</option>
                                        {params.asset_groups.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>
                                                {stuff.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">{tS("filter.label.asset_group")}</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-islands"
                                        name="island_id"
                                        aria-label={tS("filter.select.island")}
                                        data-select="island"
                                        value={dataSelects.island}
                                        onChange={onChange}>
                                        <option value="">{tS("filter.select.option")}</option>
                                        {params.islands.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>
                                                {stuff.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">{tS("filter.label.island")}</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-models"
                                        name="model_id"
                                        aria-label={tS("filter.select.model")}
                                        data-select="model"
                                        value={dataSelects.model}
                                        onChange={onChange}>
                                        <option value="">{tS("filter.select.option")}</option>
                                        {params.models.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>
                                                {stuff.name}
                                            </option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">{tS("filter.label.model")}</label>
                                </div>
                            </li>
                            <li>
                                <div className="form-floating ms-3 mt-1">
                                    <select
                                        className="form-select"
                                        id="filter-config"
                                        name="config_id"
                                        aria-label={tS("filter.select.config")}
                                        data-select="config"
                                        value={dataSelects.config}
                                        onChange={onChange}>
                                        <option value="">{tS("filter.select.option")}</option>
                                        {params.configs.map((stuff, idx) => (
                                            <option key={idx} value={stuff.id}>{`${stuff.name} (${stuff.model})`}</option>
                                        ))}
                                    </select>
                                    <label htmlFor="filter-modes">{tS("filter.label.config")}</label>
                                </div>
                            </li>
                        </ul>
                    </div>
                </div>
            </nav>
            <div className="row" style={{height: "70px"}}></div>
        </>
    );
};

export default TopBarActions;
